export const URLS = {
  AUTH_LOCATION_MANAGEMENT: '/locationManagement/locations',
  AUTH_LOCATION_MANAGEMENT_DETAILS: '/locationManagement/locations/:id'
}

export enum PermissionRoles {
  GG_RO_DEX_LOCATION_MANAGEMENT_ADMIN = 'GG_RO_DEX_LOCATION_MANAGEMENT_ADMIN',
  GG_RO_DEX_LOCATION_MANAGEMENT_USER = 'GG_RO_DEX_LOCATION_MANAGEMENT_USER'
}

export const roles = {
  createRoles: [PermissionRoles.GG_RO_DEX_LOCATION_MANAGEMENT_ADMIN],
  editRoles: [PermissionRoles.GG_RO_DEX_LOCATION_MANAGEMENT_ADMIN],
  deleteRoles: [PermissionRoles.GG_RO_DEX_LOCATION_MANAGEMENT_ADMIN]
}
